/**   
 * api接口统一管理
 */
import { get, post } from './http'

/**
 * 获取报告
*/
export const getReport = p => get('order/show/getReport', p);





// WEBPACK FOOTER //
// ./src/request/api.js